import Icon from "../icons";

interface Props {
  numGlobes: number | undefined;
}

/**
 * Component for a globe icon used in sustainability rating.
 * @param interface
 * @returns an svg globe.
 */
export const GlobeComponent = ({ numGlobes }: Props) => {
  const maxGlobes = 5;

  return (
    <div className="flex flex-row space-x-1">
      {[...Array(maxGlobes)].map((_, i) => {
        return (
          <div key={i} className={getGlobeColor(numGlobes, i)}>
            <Icon name="globeHeroIcon" size="xxsmall" />
          </div>
        );
      })}
    </div>
  );
};

const getGlobeColor = (numGlobes: number | undefined, index: number) => {
  if (numGlobes === undefined) return "text-grey";
  if (numGlobes > index) return "text-green";
  return "text-grey";
};
